import { UAParser } from 'ua-parser-js'

export const isBrowserSupported = (browser: any) => {
  if (!browser || !browser?.name || !browser.version) return true

  try {
    const name = browser.name.toLowerCase()
    const majorVersion = parseInt(browser.major)
    const minorVersion = parseInt(browser.version?.split('.')?.[1] || 0)

    if (name.includes('chrome')) {
      if (majorVersion < 86) return false
    } else if (name.includes('edge')) {
      if (majorVersion < 86) return false
    } else if (name.includes('firefox')) {
      if (majorVersion < 98) return false
    } else if (name.includes('opera')) {
      if (majorVersion < 72) return false
    } else if (name.includes('safari')) {
      if (majorVersion <= 15 && minorVersion < 4) return false
    } else if (name.includes('ie')) {
      return false
    }
  } catch (err) {
    return true
  }

  return true
}

export const isSafariBrowser = () => {
  if (typeof navigator !== 'undefined') {
    const parser = new UAParser(navigator.userAgent)
    const browser = parser.getBrowser()
    return browser.name === 'Safari'
  }

  return false
}

export const isIOSMobile = () => {
  if (typeof navigator !== 'undefined') {
    const parser = new UAParser(navigator.userAgent)
    const device = parser.getDevice()
    const os = parser.getOS()
    return os.name === 'iOS' && device.type === 'mobile'
  }

  return false
}
